import { MenuItem, Select, Stack, Typography } from '@mui/material';
import { capitalize } from '@shared';
import { RowsPerPagePropsType } from './TableTitle.types';

export const RowsPerPageSelector = ({
  entityName,
  value,
  handleChange,
  options,
}: RowsPerPagePropsType) => {
  const title = `${capitalize(entityName)}s per page:`;
  const variants = options || [20, 50, 100, 200];
  return (
    <Stack direction='row' spacing={2} alignItems='center'>
      <Typography variant='body2'>{title}</Typography>
      <Select sx={{ backgroundColor: '#fff' }} size='small' value={value} onChange={handleChange}>
        {variants.map((v) => (
          <MenuItem key={v} value={v}>
            {v}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};
